<template>
  <div class="clause-dialog">
    <el-dialog
      :visible.sync="locIsShow"
      :show-close="false"
      :center="true"
      :before-close="beforeClose"
      width="60%"
      style="height: 720px; margin-top: 30px;"
    >
      <div
        style="
          font-size: 18px;
          line-height: 25px;
          height: 600px;
          margin-top: 10px;
        "
      >
        <div class="clause-title">
          预订条款
        </div>
        <div class="clause-item" v-for="(item, i) in textData" :key="i">
          <div class="clause-item-title">
            {{ item.title }}
          </div>
          <div
            class="clause-item-text"
            v-for="(value, j) in item.values"
            :key="j"
          >
            {{ value }}
          </div>
        </div>
        <div style="text-align: center; margin-top: 20px; padding-bottom: 30px;">
          <el-button type="primary" style="width: 120px;" @click="doClose">
            返回
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      locIsShow: false,
      textData: [
        { title: "第一条 特别提示", values: ["深圳市科坦科技有限公司（以下简称“本公司”）通过酒店智能预订服务平台为用户提供预订住宿服务，住宿服务由住宿提供方提供。在通过酒店智能预订服务平台向本公司预订开始前，请仔细阅读本须知，本须知及产品页面中的重要条款作为本公司与预订人（下方所称“您”，代以“您”统称入住人和预订人应知晓和遵守的内容）双方协议的重要内容。当您勾选同意并进一步预订本产品时，表明您仔细阅读并接受协议的所有条款。本公司提供网络预订服务，帮助您向住宿提供方预订客房，本公司并不经营住宿业务。"] },
        {
          title: "第二条 预订注意事项", values: [
            "1.科坦的酒店价格包含酒店服务费，但不含酒店内消费的其他费用。",
            "2.您提出的特殊需求酒店方不能保证实现，我们会及时将确认情况反馈给您。",
            "3.订单需等酒店或供应商确认后生效，订单确认结果以短信或邮件通知为准。",
            "4.请在填写订单时，务必留下准确的联系方式：电话、Email等，以便客服与您联系预订相关事宜。",
            "5.您在订单中填写的最晚到达时间如有变化，请及时与科坦客服联系。"
          ]
        },
        {
          title: "第三条 订单生效", values: [
            "订单生效的定义：产品预订成功后，本公司通过酒店智能预订服务平台给您发送确认信息，该订单即生效。"
          ]
        },
        {
          title: "第四条 您主动更改或取消已生效订单", values: [
            "订单生效后，您可以在入住前通知本公司更改或取消您所做预订，取消和更改订单需遵循预订流程中已披露的取消政策，可能依照政策产生相应违约费用。"
          ]
        },
        {
          title: "第五条 不可抗力", values: [
            "因不可抗力(包括地震、台风、雷击、水灾、火灾等自然原因，以及战争、政府行为、黑客攻击、电信部门技术管制等原因)不能履行或不能继续履行已生效订单约定内容的，本公司和您均不承担违约责任，但法律另有规定的除外。"
          ]
        },
        {
          title: "第六条 争议解决", values: [
            "在您的预订生效后，如果在订单约定内容履行过程中，您对相关事宜的履行发生争议，您同意按照中华人民共和国颁布的相关法律法规来解决争议，并同意接受深圳市宝安区人民法院的管辖。"
          ]
        },
        {
          title: "第七条 其它", values: [
            "本须知未尽的其他事项，由双方协商解决。"
          ]
        }
      ]
    }
  },
  methods: {
    beforeClose (done) {
      this.$emit('closeDialog')
      done()
    },
    doClose () {
      this.locIsShow = false
      this.$emit('closeDialog')
    }
  },
  watch: {
    isShow (val) {
      this.locIsShow = val
    }
  }
}
</script>

<style lang="stylus" scoped>
.clause-title {
  text-align: center;
  font-size: 40px;
  font-weight: 600;
}
.clause-item {
  padding-left: 40px;
  padding-right: 40px;
  line-height: 30px;
  margin-top: 10px;
}
.clause-item-title {
  font-size: 20px;
  font-weight: 600;
}
.clause-item-text {
  font-size: 18px;
  margin-top: 5px;
}

.clause-dialog >>> .el-dialog {
  border-radius: 0;
  overflow: auto;
}

.clause-dialog >>> .el-dialog__header {
  height: 0;
  padding: 0;
}

.clause-dialog >>> .el-dialog__body {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/frame/components/ClauseDialog.vue